import { Routes, Route } from 'react-router-dom';
import Home from './pages/Home';
import About from './pages/About';
import Articles from './pages/Articles';
import ArticlePost from './pages/ArticlePost';
import Creations from "./pages/Creations.jsx";
import Iq from "./pages/Iq.jsx";

import React from 'react';

function App() {
    return (
        <div className="min-h-screen flex flex-col">
            <div className="flex-grow">
                <Routes>
                    <Route path="/" element={<Home />} />
                    <Route path="/about" element={<About />} />
                    <Route path="/iq" element={<Iq />} />
                    <Route path="/creations" element={<Creations />} />
                    <Route path="/articles" element={<Articles />} />
                    <Route path="/articles/:slug" element={<ArticlePost />} />
                </Routes>
            </div>
        </div>
    );
}

export default App;
